import { Div, Flex, Grid, H3, Link, Skeleton } from '@dnb/eufemia';
import styled from '@emotion/styled';
import classNames from 'classnames';
import { Link as RouterLink } from 'react-router-dom';

import { useBackend } from '@/hooks/useBackend';
import { handleSWRErrorLocally } from '@/utils/swrOpenapiUtils';

import style from './index.module.css';

type SeverityStatus = 'OK' | 'INSTABILITIES' | 'REDUCED_SERVICE';

const statusTitle: Record<SeverityStatus, string> = {
  OK: 'All APIs are operational',
  INSTABILITIES: 'Some APIs may have instabilities',
  REDUCED_SERVICE: 'Some APIs have reduced service',
};

const ApiStatusWidgetWrapper = styled(Flex.Horizontal)`
  height: 100%;
`;

export default function ApiStatusWidget() {
  const { data: highestSeverity, isLoading } = useBackend('/api-status/highest-severity', {}, handleSWRErrorLocally);

  const status: SeverityStatus = highestSeverity ?? (isLoading ? 'OK' : 'REDUCED_SERVICE');

  return (
    <Skeleton show={isLoading}>
      <Div className={style['apiStatusWidget']}>
        <Grid.Container columnGap="small" columns={10} rowGap="small">
          <Grid.Item span={[1, 1]}>
            <ApiStatusWidgetWrapper align="center" justify="center">
              <div className={classNames(style['apiStatusBadge'], style[`apiStatusBadge-severity-${status}`])} />
            </ApiStatusWidgetWrapper>
          </Grid.Item>
          <Grid.Item span={[2, 10]}>
            <H3 bottom="0.25rem" top="0.25rem">
              {statusTitle[status]}
            </H3>
          </Grid.Item>
          <Grid.Item span={[2, 9]}>
            <Link element={RouterLink} to="/status">
              API status overview
            </Link>
          </Grid.Item>
        </Grid.Container>
      </Div>
    </Skeleton>
  );
}
